module.exports = __webpack_public_path__ + "media/fyt_m22.533ec7fe.mp4";